import useCdm from './useCdm'
import useLedm from './useLedm'
import { Logger } from 'src/utils/helpers'

const usePrinter = ({
  ledmDiscoveryTree = null,
  cdmDiscoveryTree = null,
  iccManifest = null
} = {}) => {
  const _ledmDiscoveryTree = JSON.parse(ledmDiscoveryTree)
  const _cdmDiscoveryTree = JSON.parse(cdmDiscoveryTree)
  const _iccManifest = JSON.parse(iccManifest)
  const {
    fetchSystemIdentity,
    fetchInternetDiagnostics,
    patchInternetDiagnostics
  } = useCdm()
  const {
    fetchProductConfigDyn,
    fetchEPrintManifest: _fetchEPrintManifest,
    fetchIccManifest: _fetchIccManifest,
    fetchGen2CloudServiceManifest: _fetchGen2CloudServiceManifest,
    fetchIccStatus: _fetchIccStatus,
    patchIccJob
  } = useLedm()

  const fetchDeviceInfo = async () => {
    const result = {
      productNumber: null,
      uuid: null,
      serialNumber: null,
      modelName: null
    }
    const resp = ledmDiscoveryTree
      ? await fetchProductConfigDyn(_ledmDiscoveryTree)
      : await fetchSystemIdentity(_cdmDiscoveryTree)
    if (!resp?.body?.data) return result
    if (ledmDiscoveryTree) {
      result.productNumber =
        resp.body.data?.['prdcfgdyn2:ProductConfigDyn']?.[
          'prdcfgdyn:ProductInformation'
        ]?.['dd:ProductNumber']
      result.uuid =
        resp.body.data?.['prdcfgdyn2:ProductConfigDyn']?.[
          'prdcfgdyn:ProductInformation'
        ]?.['dd:UUID']
      result.serialNumber =
        resp.body.data?.['prdcfgdyn2:ProductConfigDyn']?.[
          'prdcfgdyn:ProductInformation'
        ]?.['dd:SerialNumber']
      result.modelName =
        resp.body.data?.['prdcfgdyn2:ProductConfigDyn'][
          'prdcfgdyn:ProductInformation'
        ]['dd:MakeAndModelBase']
    } else {
      result.productNumber = resp.body.data?.['productNumber']
      result.uuid = resp.body.data?.['deviceUuid']
      result.serialNumber = resp.body.data?.['serialNumber']
      result.modelName = resp.body.data?.['makeAndModel']['base']
    }
    return result
  }

  const fetchEPrintManifest = async () => {
    if (!ledmDiscoveryTree) {
      Logger.warn('CDM does not support ePrint manifest')
      return null
    }
    const resp = await _fetchEPrintManifest(_ledmDiscoveryTree)
    if (!resp?.body?.data) return null
    return resp.body.data
  }

  const fetchIccManifest = async () => {
    if (!ledmDiscoveryTree) {
      Logger.warn('CDM does not support ICC manifest')
      return null
    }
    const resp = await _fetchIccManifest(_ledmDiscoveryTree)
    if (!resp?.body?.data) return null
    return resp.body.data
  }

  const fetchGen2CloudServiceManifest = async () => {
    if (!ledmDiscoveryTree) {
      Logger.warn('CDM does not support Gen2 Cloud Service manifest')
      return null
    }
    const resp = await _fetchGen2CloudServiceManifest(_ledmDiscoveryTree)
    if (!resp?.body?.data) return null
    return resp.body.data
  }

  const fetchIccStatus = async (isIccOverCdm = false) => {
    if (!isIccOverCdm) {
      return await _fetchIccStatus(_iccManifest)
    }
    return await fetchInternetDiagnostics(_cdmDiscoveryTree)
  }

  const patchIcc = async (version, isIccOverCdm = false) => {
    if (!isIccOverCdm) {
      return await patchIccJob(_iccManifest)
    }
    return await patchInternetDiagnostics(_cdmDiscoveryTree, version)
  }

  return {
    fetchDeviceInfo,
    fetchEPrintManifest,
    fetchIccManifest,
    fetchGen2CloudServiceManifest,
    fetchIccStatus,
    patchIcc
  }
}

export default usePrinter
